import React from 'react';

import { footer, footerData } from '../../../Constants/user';

import './footer.scss';

export default  ({ language }) => {
    const footerContent = footerData.find(({ lang }) => lang === language);

    return (
        <footer>
            <div id={'footerLeft'}>
                <div> <span>{footerContent.address}</span></div>
                <div> <span>{footerContent.email}</span></div>
                <div> <span>{footerContent.phone}</span></div>
            </div>
            <div id={'footerRight'}>
                <div>
                    <a href="mailto:info@bimconsulting.am">
                        <img src={'/images/userPage/Icons/baseline_email_black_18dp.png'} alt />
                    </a>
                </div>
                <div>
                    <a
                        target={'blank'}
                        href="https://www.google.com/maps/place/IT+PARK+Business+Center/@40.2002583,44.4747875,18.97z/data=!4m5!3m4!1s0x406abd142295fa4b:0x4c0048923a8c2192!8m2!3d40.2006353!4d44.4750434"
                    >
                        <img src={'/images/userPage/Icons/baseline_location_on_black_18dp.png'} alt />
                    </a>
                </div>
                <div>
                    <a
                        target={'blank'}
                        href="https://www.facebook.com/bimconsulting.am"
                    >
                        <img src={'/images/userPage/Icons/fb.png'} alt />
                    </a>
                </div>
                <div>
                    <a
                        target={'blank'}
                        href="https://www.linkedin.com/company/bim-consulting-yerevan"
                    >
                        <img src={'/images/userPage/Icons/in.png'} alt />
                    </a>
                </div>
            </div>
        </footer>
    )
}
